import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (!loading && user) { window.location.href = "/admin"; return null; }

  const submit = async (e) => {
    e?.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/login", f);
      window.location.href = "/admin";
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login gagal. Coba lagi.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ink text-cream grid place-items-center px-5 py-10">
      <div className="w-full max-w-sm">
        <div className="text-center">
          <div className="font-display text-3xl tracking-tight">Lapak<span className="text-lm-red">Mahjong</span>.id</div>
          <p className="mt-2 text-cream/60 text-sm">Admin Dashboard</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="password-login-form">
          <input data-testid="login-email" type="email" autoComplete="username" placeholder="Email"
            value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })}
            className="w-full h-12 rounded-lg bg-white/10 border border-white/15 px-4 text-sm placeholder:text-cream/40 focus:border-lm-gold outline-none" />
          <input data-testid="login-password" type="password" autoComplete="current-password" placeholder="Password"
            value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
            className="w-full h-12 rounded-lg bg-white/10 border border-white/15 px-4 text-sm placeholder:text-cream/40 focus:border-lm-gold outline-none" />
          {err && <p data-testid="login-error" className="text-xs text-lm-red">{err}</p>}
          <button data-testid="login-submit" type="submit" disabled={busy}
            className="w-full bg-lm-red rounded-full py-3.5 text-sm font-semibold hover:brightness-110 transition disabled:opacity-60 inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="animate-spin" size={15} />} Masuk
          </button>
        </form>

        <p className="mt-6 text-center text-[11px] text-cream/40">
          Lupa password? Minta owner reset dari halaman Staff Accounts.
        </p>
        <a href="/" className="mt-4 block text-center text-xs text-cream/50 hover:text-lm-gold">← Back to website</a>
      </div>
    </div>
  );
}
